import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

export class PaymentDetailController {

  public static $inject = ['ACTToolbarService', 'payment', 'activities', '$scope', 'breadcrumbService'];

  constructor(
    private ActToolbarService: ACTToolbarService,
    public payment,
    public activities,
    private $scope,
    private breadcrumbService: BreadcrumbService
  ) {
      this.activate();
  }

  private activate() {
    this.breadcrumbService.addBreadcrumb({
      name: 'Payments',
      sref: 'customer.payments'
    });
    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle(this.payment.paymentReference);
      toolbar.setActiveTab(8);
    });

    this.$scope.$on('$destroy', () => {
      this.breadcrumbService.removeLastBreadcrumb();
    });
  }
}